import api from './api'

// Tipos para el horario de un día
export interface DaySchedule {
  enabled: boolean
  startTime: string // HH:mm format
  endTime: string   // HH:mm format
}

// Tipo para el horario semanal completo
export interface WeeklySchedule {
  monday: DaySchedule
  tuesday: DaySchedule
  wednesday: DaySchedule
  thursday: DaySchedule
  friday: DaySchedule
  saturday: DaySchedule
  sunday: DaySchedule
}

// DTO para BusinessHours
export interface BusinessHoursDTO {
  businessHoursEnabled: boolean
  timezone: string
  weeklySchedule: WeeklySchedule
  offHoursBehavior: 'respond_with_offline_message' | 'use_ai_with_notice' | 'silence'
  offHoursMessage: string
}

// Estado actual de horarios
export interface BusinessHoursStatus {
  isOpen: boolean
  currentDay: string
  currentTime: string
  schedule: DaySchedule | null
  behavior: BusinessHoursDTO['offHoursBehavior']
  message: string
}

/**
 * Obtiene la configuración de horarios de atención
 */
export async function getBusinessHours(): Promise<BusinessHoursDTO> {
  const response = await api.get<BusinessHoursDTO>('/bot/business-hours')
  return response.data
}

/**
 * Actualiza la configuración de horarios de atención
 */
export async function updateBusinessHours(data: Partial<BusinessHoursDTO>): Promise<BusinessHoursDTO> {
  const response = await api.put<BusinessHoursDTO>('/bot/business-hours', data)
  return response.data
}

/**
 * Obtiene el estado actual (si está abierto o cerrado)
 */
export async function getBusinessHoursStatus(): Promise<BusinessHoursStatus> {
  const response = await api.get<BusinessHoursStatus>('/bot/business-hours/status')
  return response.data
}

export const businessHoursApi = {
  getBusinessHours,
  updateBusinessHours,
  getBusinessHoursStatus,
}

export default businessHoursApi
